<template>
  <input
    v-if="inputType === 'email'"
    v-model="inputValue"
    :class="[{'spl-input--valid': !invalid && !isEmpty}, {'spl-input--invalid': invalid}, {'spl-input--nomargin': nomargin}, 'spl-input']"
    :min="min"
    :max="max"
    :name="name"
    :placeholder="placeholder"
    type="email"
    @keyup.enter="enterPressed"
    @focus="stopValidation"
    @blur="startValidation">
  <input
    v-else-if="inputType === 'password'"
    v-model="inputValue"
    :class="[{'spl-input--valid': !invalid && !isEmpty}, {'spl-input--invalid': invalid}, {'spl-input--nomargin': nomargin}, 'spl-input']"
    :min="min"
    :max="max"
    :name="name"
    :placeholder="placeholder"
    type="password"
    @keyup.enter="enterPressed"
    @focus="stopValidation"
    @blur="startValidation">
  <input
    v-else-if="inputType === 'number'"
    v-model="inputValue"
    :class="[{'spl-input--valid': !invalid && !isEmpty}, {'spl-input--invalid': invalid}, {'spl-input--nomargin': nomargin}, 'spl-input']"
    :min="min"
    :max="max"
    :name="name"
    :placeholder="placeholder"
    type="number"
    @keyup.enter="enterPressed"
    @focus="stopValidation"
    @blur="startValidation">
  <input
    v-else-if="inputType === 'float'"
    v-model="inputValue"
    :class="[{'spl-input--valid': !invalid && !isEmpty}, {'spl-input--invalid': invalid}, {'spl-input--nomargin': nomargin}, 'spl-input']"
    :name="name"
    :placeholder="placeholder"
    @keyup.enter="enterPressed"
    @focus="stopValidation"
    @blur="startValidation">
  <!-- Default is type text -->
  <input
    v-else
    v-model="inputValue"
    :class="[{'spl-input--valid': !invalid && !isEmpty}, {'spl-input--invalid': invalid}, {'spl-input--nomargin': nomargin}, 'spl-input']"
    :min="min"
    :max="max"
    :name="name"
    :placeholder="placeholder"
    type="text"
    @keyup.enter="enterPressed"
    @focus="stopValidation"
    @blur="startValidation">
</template>

<script>
import { trim } from 'lodash'

export default {
  name: 'FormInput',
  props: [
    'name',
    'placeholder',
    'type',
    'min',
    'max',
    'invalid',
    'nomargin',
    'index',
    'value',
    'enableTrim'
  ],
  data () {
    return {
      inputValue: this.setInputValue(),
      inputType: this.type || 'text'
    }
  },
  computed: {
    isEmpty () {
      if (this.inputValue === null || this.inputValue === undefined || !this.inputValue.trim) {
        return this.inputValue === ''
      } else if (this.inputValue != null) {
        return this.inputValue.trim() === ''
      } else {
        return false
      }
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.inputValue = newVal
    },
    inputValue (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.inputType === 'float') {
          var numberValue = 0
          if (newVal && newVal.indexOf && newVal.indexOf(',') !== -1) {
            numberValue = newVal.replace(',', '.')
            numberValue = parseFloat(numberValue)
          } else {
            numberValue = newVal
          }
          if (isNaN(numberValue)) {
            numberValue = newVal
          }
          setTimeout(() => {
            this.$emit('input', numberValue, this.index)
          }, 0)
        } else {
          setTimeout(() => {
            if (this.enableTrim === true) {
              this.inputValue = trim(this.inputValue)
            }
            this.$emit('input', this.inputValue, this.index)
          }, 0)
        }
      }
    }
  },
  methods: {
    stopValidation () {
      this.doValidation = false
      this.$emit('focus')
    },
    startValidation () {
      this.doValidation = true
      this.$emit('blur')
    },
    enterPressed () {
      this.$emit('enterPressed')
    },
    setInputValue () {
      return this.value || ''
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";

.spl-input {
  appearance: none;
  background-color: #fff;
  border: 1px solid $lightYellowBorder;
  border-radius: 4px;
  color: $mainInputColor;
  font-family: $opensans;
  font-size: 14px;
  height: 40px;
  padding: 10px 15px;
  margin-bottom: $mainBottomMargin;
  transition: opacity $shortTransition ease-in-out;
  width: 100%;

  @include mobile() {
    font-size: 16px;
    margin-bottom: 0;
  }
  &[type="number"] {
    padding-right: 2px;
    width: 80px;
  }
  &--nomargin {
    margin-bottom: 0;
  }
  &[disabled] {
    opacity: 0.4;
  }
  &::-webkit-input-placeholder {
    color: $formPlaceholderColor;
  }
  &::-moz-placeholder {
    color: $formPlaceholderColor;
  }
  &:-ms-input-placeholder {
    color: $formPlaceholderColor;
  }
  &:-moz-placeholder {
    color: $formPlaceholderColor;
  }
  &--invalid {
    background-color: $redBackgroundLight;
    border-color: $errorRed;
  }
  &--valid {
    background-image: url(../../assets/icon-check.svg);
    background-position: right 10px center;
    background-repeat: no-repeat;
  }
}
</style>
